import { useEffect } from 'react';

import inServerContext from 'bundles/ssr/util/inServerContext';

// When we perform a client-side route transition, like when a course item is clicked on an s12n page,
// the scroll window is often in the middle of the page. This checks if there is no hash anchor tag in the URL
// and scrolls the page to the top for better UX.
const useClientSideRouteCheck = () => {
  useEffect(() => {
    if (!inServerContext && !window.location.href.includes('#') && window.scrollY > 0) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
  }, []);
};

export default useClientSideRouteCheck;
